// src/services/mediaConversion/mediaConversionApi.ts

import type {
  MediaConversionJobDTO,
  MediaJobTarget,
  MediaJobTargetObject,
  MediaJobTargetSlug,
} from "@/types/mediaConversion/mediaJob";

import baseApi from "../../lib/baseApi";

type JobsArray = MediaConversionJobDTO[];

// DRF pagination shape (if enabled)
type PaginatedJobs = {
  count: number;
  next: string | null;
  previous: string | null;
  results: MediaConversionJobDTO[];
};

type JobsResponse = JobsArray | PaginatedJobs;

function unwrapJobs(data: JobsResponse): MediaConversionJobDTO[] {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray((data as any).results)) return (data as PaginatedJobs).results;
  return [];
}

async function get<T>(url: string, params: Record<string, any>): Promise<T> {
  const res = await baseApi.get(url, { params });
  return res.data as T;
}

const BASE = "/media-conversion/media-jobs";

export async function getJobsForTarget(
  target: MediaJobTarget,
  opts?: { fieldName?: string }
): Promise<MediaConversionJobDTO[]> {
  const fieldName = (opts?.fieldName || "").trim() || undefined;

  if (target.by === "slug") {
    const t = target as MediaJobTargetSlug;
    const data = await get<JobsResponse>(`${BASE}/for-slug/`, {
      app_label: t.appLabel,
      model: t.model,
      slug: t.slug,
      field_name: fieldName,
    });
    return unwrapJobs(data);
  }

  const t = target as MediaJobTargetObject;

  if (t.by === "ct") {
    const data = await get<JobsResponse>(`${BASE}/for-object/`, {
      content_type_id: t.contentTypeId,
      object_id: t.objectId,
      field_name: fieldName,
    });
    return unwrapJobs(data);
  }

  // by model
  const data = await get<JobsResponse>(`${BASE}/for-object/`, {
    app_label: t.appLabel,
    model: t.model,
    object_id: t.objectId,
    field_name: fieldName,
  });
  return unwrapJobs(data);
}
